export function getBucketViewSystemID() {
  let urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('s3_prefix')) {
    const s3Prefix = urlParams.get('s3_prefix').slice(0, -1);
    const lastPrefix = s3Prefix.substring(s3Prefix.lastIndexOf('/') + 1);
    if (
      lastPrefix &&
      !isNaN(lastPrefix) &&
      lastPrefix.length >= 7 &&
      lastPrefix.length <= 12
    ) {
      return lastPrefix;
    }
  }
}
